import React, { useEffect } from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import HomePage from '../views/HomePage';
import LoginPage from '../views/LoginPage';
import ProtectedRoute from './ProtectedRoute';
import { LoginServices } from '../services/LoginServices';
import ConfigurationPage from '../views/ConfigurationPage';
import ModelReportDatesBar from '../views/ModelReportDatesBar';
import { useData } from '../services/DataContext';
import { IndicatorServices } from '../services/IndicatorServices';
import Loading from "../components/Loading/Loading";
import ReplayIcon from '@mui/icons-material/Replay';

function RoutesIndex() {
  const { dataset, setDataset } = useData();
  const { setSideBarDataset } = useData();
  const { setUserInfo } = useData();
  const dataArray = Object.values(dataset);
  const userLogged = LoginServices.verifySession();
  const [loading, setLoading] = React.useState(true);
  const [errorMessage, setErrorMessage] = React.useState(null);

  useEffect(() => {
    const fetchData = async () => {
      try {
        if (userLogged) {
          const result = await LoginServices.currentUser();
          setUserInfo(result);
          await IndicatorServices.renderSideBar()
            .then((data) => {
              setSideBarDataset(data);
              setDataset(data);
            })
            .catch((error) => setErrorMessage(error))
            .finally(() => setLoading(false));
        }
      } catch (error) {
        setErrorMessage(error);
      }
    };
    fetchData().then();
  }, [userLogged, setDataset, setSideBarDataset, setUserInfo]);



  if (loading && userLogged && !errorMessage) {
    return (
      <div className="flex flex-column justify-center items-center h-screen">
        <Loading/>
      </div>
    );
  }

  if(errorMessage) {
    return (
      <div className="flex flex-row justify-center items-center h-screen">
        <div className="text-center">
          <h1 className="text-2xl text-red-500">Erro ao carregar os dados atualize a página. </h1>
          <h1 className="text-2xl text-red-500">Caso o problema persista, contate um administrador!</h1>
          <ReplayIcon className="text-red-500 mt-5 hover:text-red-700 cursor-pointer" onClick={() => window.location.reload()} />

        </div>
      </div>
    );
  }

  return (
    <BrowserRouter>
      <Routes>
        <Route path="/login" element={LoginServices.verifySession() ? <Navigate to="/research-progress" replace /> : <LoginPage />} />
        <Route element={<ProtectedRoute />}>
          <Route path="/research-progress" element={<HomePage />} />
          <Route path="/configuration" element={<ConfigurationPage />} />
          {dataArray.map((item) =>
            item.map((subItem) => (
              <Route
                key={subItem["indicatorId"]}
                path={`/indicators/${subItem["id"]}`}
                element={<ModelReportDatesBar report={subItem["id"]} />}
              />
            ))
          )}
        </Route>
        <Route path="*" element={<Navigate to="/research-progress" replace />} />
      </Routes>
    </BrowserRouter>
  );
}

export default RoutesIndex;